import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { TEMPLATE } from "./actionTypes";

const INIT_STATE = {
  listaTemplate: {
    totalRecords: 0,
    records: [],
  },
  loadingTemplate: true,
  filterTemplate: null,
  template: null,
  messageTemplate: null,
  isTemplateSave: null,

  listaTemplateHistory: [],
  loadingTemplateHistory: true,

  errorLoadingTemplate: null,
  errorLoadingTemplateHistory: null,
  pageSizeTemplate: DEFAULT_PAGE_SIZE,
};

const TemplateReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TEMPLATE.GET_LIST.REQUEST:
      return {
        ...state,
        filterTemplate: action.payload,
        loadingTemplate: true,
      };
    case TEMPLATE.GET_LIST.SUCCESS:
      return {
        ...state,
        listaTemplate: action.payload,
        loadingTemplate: false,
      };
    case TEMPLATE.GET_LIST.FAIL:
      return {
        ...state,
        messageTemplate: action.payload,
        loadingTemplate: false,
      };

    case TEMPLATE.GET_TEMPLATE.REQUEST:
      return {
        ...state,
        loadingTemplate: true,
      };
    case TEMPLATE.GET_TEMPLATE.SUCCESS:
      return {
        ...state,
        template: action.payload,
        loadingTemplate: false,
      };
    case TEMPLATE.GET_TEMPLATE.FAIL:
      return {
        ...state,
        messageTemplate: action.payload,
        loadingTemplate: false,
        errorLoadingTemplate: true,
      };

    case TEMPLATE.SAVE_TEMPLATE.REQUEST:
      return {
        ...state,
        loadingTemplate: true,
      };
    case TEMPLATE.SAVE_TEMPLATE.SUCCESS:
      return {
        ...state,
        isTemplateSave: action.payload,
        loadingTemplate: false,
      };
    case TEMPLATE.SAVE_TEMPLATE.FAIL:
      return {
        ...state,
        loadingTemplate: false,
        isTemplateSave: false,
        messageTemplate: action.payload,
      };

    case TEMPLATE.LOAD_EMPTY:
      return {
        ...state,
        template: null,
        loadingTemplate: false,
        errorLoadingTemplate: null,
        errorLoadingTemplateHistory: null,
      };
    case TEMPLATE.CLEAN_MESSAGE:
      return {
        ...state,
        messageTemplate: null,
        loadingTemplate: false,
        isTemplateSave: null,
      };

    case TEMPLATE.GET_TEMPLATE_HISTORY.REQUEST:
      return {
        ...state,
        loadingTemplate: true,
      };
    case TEMPLATE.GET_TEMPLATE_HISTORY.SUCCESS:
      return {
        ...state,
        template: action.payload,
        loadingTemplate: false,
      };
    case TEMPLATE.GET_TEMPLATE_HISTORY.FAIL:
      return {
        ...state,
        loadingTemplate: false,
        messageTemplate: action.payload,
        errorLoadingTemplateHistory: true,
      };

    case TEMPLATE.GET_TEMPLATE_HISTORY_LIST.REQUEST:
      return {
        ...state,
        loadingTemplateHistory: true,
      };
    case TEMPLATE.GET_TEMPLATE_HISTORY_LIST.SUCCESS:
      return {
        ...state,
        listaTemplateHistory: action.payload,
        loadingTemplateHistory: false,
      };
    case TEMPLATE.GET_TEMPLATE_HISTORY_LIST.FAIL:
      return {
        ...state,
        loadingTemplateHistory: false,
        errorLoadingTemplateHistory: true,
      };
    case TEMPLATE.CHANGE_PAGE_SIZE_TEMPLATE:
      return {
        ...state,
        pageSizeTemplate: action.payload,
      };
    default:
      return state;
  }
};

export default TemplateReducer;
